<template>
  <div class="user-management-excc-auth-form main-second-bg">
    <p class="user-management-child-header b-1-cl a-3-bd">{{$t('personal.idAuth.title')}}</p>
    <div class="user-management-center">
      <div class="certification-process">
        <div class="div-line a-3-bd clearfix"></div>
        <div class="step-left main-second-bg">
          <p :class="this.activeP1">
            <span class="span-mark b-8-cl clearfix a-12-bg">1</span>
            {{$t('personal.idAuth.info')}}</p>
        </div>
        <div class="step-center main-second-bg">
          <p :class="this.activeP2">
            <span class="span-mark b-8-cl clearfix" :class="this.activeS2">2</span>
            {{$t('personal.idAuth.uploadDocuments')}}</p>
        </div>
        <div class="step-right main-second-bg">
          <p :class="this.activeP3">
            <span class="span-mark b-8-cl clearfix" :class="this.activeS3">3</span>
            {{$t('personal.idAuth.submitted')}}</p>
        </div>
      </div>
      <div class="idAuth-center clearfix">
        <div v-if="active === '1'">
          <!-- 姓名 -->
          <c-inputLine
              name="full_name"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText1')"
              :errorHave="true"
              maxLength="50"
              :errorFlag="checkErrorFlag2"
              marginTop="0px"
              :value="full_name"
              @onchanges="inputChanges"
            >
          </c-inputLine>
          <!-- 性别 -->
          <div class="gender">
            <span class="gender-tit">{{$t('personal.exccAuthForm.promptText2')}}</span>
            <label @click="selectGender('0')">
              <c-redio :value="sex === '0'"/>
              {{$t('personal.exccAuthForm.sex1')}}
            </label>
            <label @click="selectGender('1')">
              <c-redio :value="sex === '1'"/>
              {{$t('personal.exccAuthForm.sex2')}}
            </label>
          </div>
          <!-- 出生日期 -->
          <!-- <c-calendar
            name="birthday"
            :value="birthday"
            :promptText="$t('personal.exccAuthForm.promptText3')"
            :errorHave="true"
            :errorFlag="checkErrorFlag2"
            :defaultShowDate="defaultShowDate"
            marginTop="0px"
            @onChanges="onChangeCalendar"
          /> -->
          <!-- 出生日期 -->
          <c-inputLine
              name="birthday"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText3')"
              :errorHave="true"
              :value="birthday"
              :errorFlag="birthdayErrorFlag"
              :errorText="birthdayErrorText"
              :warningText="$t('personal.exccAuthForm.text17')"
              @onchanges="inputChanges"
            >
          </c-inputLine>
          <!-- 住宅地址 -->
          <c-inputLine
              name="address"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText4')"
              :errorHave="true"
              :errorFlag="checkErrorFlag2"
              marginTop="0px"
              maxLength="50"
              :value="address"
              @onchanges="inputChanges"
            >
          </c-inputLine>
          <!-- 市 -->
          <c-inputLine
              name="city"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText5')"
              :errorHave="true"
              :errorFlag="checkErrorFlag2"
              marginTop="0px"
              maxLength="50"
              :value="city"
              @onchanges="inputChanges"
            >
          </c-inputLine>
          <!-- 邮政编码 -->
          <c-inputLine
              name="postcode"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText6')"
              :errorHave="true"
              :errorFlag="checkErrorFlag2"
              marginTop="0px"
              maxLength="50"
              :value="postcode"
              @onchanges="inputChanges"
            >
          </c-inputLine>
          <!-- 国家或地区 -->
          <c-inputLine
              name="country"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.promptText7')"
              :errorHave="true"
              :disabled="true"
              :value="kycNationality"
            >
          </c-inputLine>
          <!-- 身份证/居住证/护照号码 -->
          <c-inputLine
            name="certificateNumber"
            maxLength="50"
            inputType="text"
            :promptText="$t('personal.exccAuthForm.promptText8')"
            :errorHave="true"
            :errorText="errorText1"
            :errorFlag="checkErrorFlag1"
            marginTop="0px"
            :value="certificateNumber"
            @onchanges="inputChanges">
          </c-inputLine>
          <!-- 收入来源 -->
          <c-select
            :filterable="true"
            :value="income"
            :promptText="$t('personal.exccAuthForm.promptText9')"
            @onChanges='incomeChange'
            name="income"
            :errorHave="true"
            :errorFlag="incomeErrorFlag"
            :errorText='errorText'
            :options="incomeList"
          />
          <!-- 您选择了其他收入来源，请描述 -->
          <c-inputLine
              v-if="income === '6'"
              name="qtTExt"
              inputType="text"
              :promptText="$t('personal.exccAuthForm.text15')"
              marginTop="0px"
              maxLength="256"
              :value="qtTExt"
              @onchanges="inputChanges"
          >
          </c-inputLine>
           <c-button
            type="solid"
            :big="true"
            :disabled="disabled"
            marginTop="18px"
            height="40px"
            width="100%"
            @click="btnLink(1)"
            >{{ $t("personal.idAuth.next") }}
          </c-button>
        </div>
        <div v-if="active === '2'">
          <div>
            <!-- 上传1 正面-->
            <div class="upload1 clearfix">
              <div class="upload1-left a-4-bg a-2-bd clearfix">
                <div v-if="firstPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p class="b-4-cl">
                    {{
                      firstPhoto
                        ? $t('personal.exccAuthForm.text10')
                        : $t('personal.exccAuthForm.text11')
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="firstPhotoImg !== ''">
                  <img :src="firstPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="firstPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload1-right clearfix" :style="bg1"></div>
            </div>
            <!-- 上传2 背面-->
            <div class="upload2 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="secondPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p class="b-4-cl">
                    {{
                      secondPhoto
                        ? $t('personal.exccAuthForm.text8')
                        : $t('personal.exccAuthForm.text9')
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="secondPhotoImg !== ''">
                  <img :src="secondPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="secondPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix" :style="bg2"></div>
            </div>
            <!-- 上传3  手持证件-->
            <div class="upload3 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="thirdPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p class="b-4-cl">
                    {{
                      thirdPhoto
                        ? $t('personal.exccAuthForm.text12')
                        : $t('personal.exccAuthForm.text13')
                    }}
                  </p>
                </div>
                <div class="loading-mc" v-if="thirdPhotoImg !== ''">
                  <img :src="thirdPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="thirdPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix" :style="bg3"></div>
            </div>
            <!-- 上传4  居住证 -->
            <div class="upload4 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="livePhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd"/>
                  <p class="b-4-cl loading-text">{{$t('personal.prompt.uploading')}}</p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p class="b-4-cl">
                    {{livePhoto ?
                    $t('personal.exccAuthForm.text1') :
                    $t('personal.exccAuthForm.text2') }}
                  </p>
                </div>
                <div class="loading-mc" v-if="livePhotoImg !== ''">
                  <img :src="livePhotoImg" class="loading-img"/>
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize= "8"
                  name= "livePhoto"
                  url= "common/upload_img"
                  :isOpenUploadImg= "isOpenUploadImg"
                  :expand= []
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish">
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix" :style="bg4"></div>
            </div>
            <div class="upload-text clearfix">
              <p>1、{{$t('personal.exccAuthForm.text3')}}</p>
              <p>2、{{$t('personal.exccAuthForm.text4')}}</p>
              <p>3、{{$t('personal.exccAuthForm.text5')}}</p>
              <p v-if="kycMetaText.length">4、{{ kycMetaText }}</p>
              <p>
                <span v-if="kycMetaText.length">5、</span>
                <span v-else>4、</span>
                {{$t('personal.exccAuthForm.text7')}}
              </p>
            </div>
            <c-button
              type="solid"
              :big="true"
              className=""
              paddingW="0px"
              :loading="loading"
              :disabled="disabled2"
              marginTop="18px"
              height="40px"
              width="100%"
              @click="btnLink(2)"
              >{{ $t("personal.tool.submit") }}</c-button
            >
          </div>
        </div>
        <div v-if="active === '3'">
          <div class="audit-information">
            <svg class="icon icon-50" aria-hidden="true">
              <use xlink:href="#icon-g_3"></use>
            </svg>
            <p>
              {{ $t("personal.idAuth.wait")[0] }} <br />{{
                $t("personal.idAuth.wait")[1]
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imgMap } from '@/utils';
import livePhotos from '@/assets/images/1/livePhoto.png';
import countryMinix from 'BlockChain-ui-privatization/PC/common-mixin/countryList/countryList';

const upload1 = imgMap.kyc_passport_a;
const upload2 = imgMap.kyc_passport_b;
const upload3 = imgMap.kyc_passport_c;
const upload4 = imgMap.livePhoto || livePhotos;

export default {
  name: 'exccAuthForm',
  mixins: [countryMinix],
  components: {
  },
  data() {
    return {
      promptTextType: this.$t('personal.idAuth.promptTextType'),
      promptText: this.$t('personal.label.promptText'),
      errorText: this.$t('personal.label.errorText'),
      authLevel: 3,
      text1: this.$t('personal.label.idCard'),
      text2: this.$t('personal.label.passport'),
      loading: false,
      firstPhotoImg: '',
      secondPhotoImg: '',
      thirdPhotoImg: '',
      livePhotoImg: '',
      firstPhotoLoading: false,
      secondPhotoLoading: false,
      thirdPhotoLoading: false,
      livePhotoLoading: false,
      checkValue1: '', // 证件号
      promptText1: this.$t('personal.label.idCardNum'),
      errorText1: '',
      checkErrorFlag1: false,
      promptText2: this.$t('personal.label.name'),
      errorText2: '',
      checkErrorFlag2: false,
      active: '1',
      disabled2: true,
      incomeErrorFlag: false,
      certificateTypeErrorFlag: false,
      imageType: '1',
      certificateTypeList: [
        {
          value: this.$t('personal.label.idCard'),
          code: 1,
        },
      ],
      kycPhone: '',
      kycMetaText: '', // 上传图片说明文案
      // 国家不可编辑
      countryDisabled: true,
      firstPhoto: '', // 身份证正面
      secondPhoto: '', // 身份证反面
      thirdPhoto: '', // 手持证件
      uploadName: '', // 当前选中的上传模块
      livePhoto: '', // 居住证图片
      full_name: '', // 姓名
      sex: '', // 性别
      birthday: '', // 出生日期
      city: '', // 市
      address: '', // 住在地址
      postcode: '', // 邮政编码
      certificateNumber: '', // 证件号码
      income: '0', // 收入来源
      qtTExt: '', // 收入来源选择其他的文案
      birthdayErrorText: '',
      birthdayErrorFlag: false,
    };
  },
  watch: {
    birthday(val) {
      if (!val.match(/^(\d{4})(-)(\d{2})(-)(\d{2})$/)) {
        this.birthdayErrorText = this.$t('personal.exccAuthForm.text16');
        this.birthdayErrorFlag = true;
      } else if (val && this.ageLimit && !this.validateAge()) {
        this.birthdayErrorText = '';
        this.birthdayErrorFlag = false;
        this.$bus.$emit('tip', { text: `${this.$t('personal.exccAuthForm.text14')}${this.ageLimit}`, type: 'error' });
      } else {
        const ar = val.split('-');
        if (Number(ar[0] > 2020) || Number(ar[1]) > 12 || Number(ar[2]) > 31) {
          this.birthdayErrorText = this.$t('personal.exccAuthForm.text16');
          this.birthdayErrorFlag = true;
        } else {
          this.birthdayErrorText = '';
          this.birthdayErrorFlag = false;
        }
      }
    },
    clientUploadType() {
      this.getImageToken();
    },
    userInfo(v) {
      if (v) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else {
          // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
    },
    authRealname(authRealname) {
      if (authRealname !== null) {
        this.loading = false;
        if (authRealname.text === 'success') {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'success' });
          this.active = '3';
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'error' });
          this.active = '1';
          this.$store.dispatch('resetType');
        }
      }
    },
  },
  computed: {
    exccKycConfig() {
      return this.$store.state.personal.exccKycConfig;
    },
    ageLimit() {
      return this.exccKycConfig ? Number(this.exccKycConfig.data.ageLimit) : 0;
    },
    defaultShowDate() {
      if (this.ageLimit && Number(this.ageLimit) > 0) {
        const curDate = (new Date()).getTime();
        const fourYearsTime = 31536000000 * Number(this.ageLimit);
        return curDate - fourYearsTime;
      }
      return null;
    },
    // 国籍
    kycNationality() {
      let str = '';
      const current = this.countryRealMap[`+${this.kycPhone}`];
      if (this.kycPhone && current) {
        const val = current.value;
        [str] = val.split(' +');
      }
      return str;
    },
    // 收入来源列表
    incomeList() {
      return [
        { code: '0', value: this.$t('personal.exccAuthorization.income1') },
        { code: '1', value: this.$t('personal.exccAuthorization.income2') },
        { code: '2', value: this.$t('personal.exccAuthorization.income3') },
        { code: '3', value: this.$t('personal.exccAuthorization.income4') },
        { code: '4', value: this.$t('personal.exccAuthorization.income5') },
        { code: '5', value: this.$t('personal.exccAuthorization.income6') },
        { code: '6', value: this.$t('personal.exccAuthorization.income7') },
      ];
    },
    isOpenUploadImg() {
      return this.$store.state.baseData.is_open_upload_img;
    },
    imgToken() {
      return this.$store.state.baseData.imgToken || {};
    },
    clientUploadType() {
      return this.$store.state.baseData.client_img_upload_open;
    },
    // 该用户是否完成nice认证
    krwPhoneAuth() {
      let str = '0';
      if (this.userInfo
        && this.userInfo.is_krw_phone_auth) {
        str = this.userInfo.is_krw_phone_auth.toString();
      }
      return str;
    },
    bg1() {
      return {
        backgroundImage: `url(${upload1})`,
      };
    },
    bg2() {
      return {
        backgroundImage: `url(${upload2})`,
      };
    },
    bg3() {
      return {
        backgroundImage: `url(${upload3})`,
      };
    },
    bg4() {
      return {
        backgroundImage: `url(${upload4})`,
      };
    },
    authRealname() {
      return this.$store.state.personal.authRealname;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    activeP1() {
      if (this.active !== '1') {
        return '';
      }
      return 'b-2-cl';
    },
    activeP2() {
      if (this.active !== '2') {
        return '';
      }
      return 'b-2-cl';
    },
    activeP3() {
      if (this.active === '3') {
        return 'b-2-cl';
      }
      return '';
    },
    activeS2() {
      if (this.active !== '1') {
        return 'a-12-bg';
      }
      return 'a-1-bg';
    },
    activeS3() {
      if (this.active === '3') {
        return 'a-12-bg';
      }
      return 'a-1-bg';
    },
    disabled() {
      if (this.income === '6' && !this.qtTExt) {
        return true;
      }
      return !(this.full_name
      && this.sex
      && this.birthday
      && this.city
      && this.address
      && this.postcode
      && this.certificateNumber
      && this.country
      && this.validateAge()
      && !this.birthdayErrorFlag);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.mountedInit();
  },
  methods: {
    init() {
      this.getImageToken();
      this.countryInit();
      this.getLang();
      if (this.userInfo) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else { // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
    },
    getLang() {
      this.axios({
        url: '/kyc/Api/getUploadImgCopywriting',
      }).then((data) => {
        if (data.code.toString() === '0') {
          if (data.data.language) {
            this.kycMetaText = data.data.language;
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    mountedInit() {
      if (!this.exccKycConfig) {
        this.$store.dispatch('exccKycConfig');
      }
    },
    countryInit() {
      if (this.$route.query) {
        if (this.$route.query.country) {
          this.kycPhone = this.$route.query.country;
          this.country = this.$route.query.countryKeyCode;
        } else if (this.$route.query.countryKeyCode) {
          this.kycPhone = this.countryMap[`+${this.$route.query.countryKeyCode}`].code.replace('+', '');
          this.country = this.$route.query.countryKeyCode;
        } else {
          this.kycPhone = '156';
          this.country = '86';
        }
      }
    },
    getImageToken() {
      const tokenData = this.imgToken[this.imageType];
      if ((!tokenData || (new Date(tokenData.Expiration).getTime() - new Date().getTime() < 30000))
        && Number(this.clientUploadType)) {
        this.$store.dispatch('getImgToken', this.imageType);
      }
    },
    uploadFinish(obj) {
      if (obj.name) {
        this.uploadName = obj.name;
      }
      if (obj.error) {
        this.$bus.$emit('tip', { text: obj.error, type: 'error' });
        return;
      }
      this[`${this.uploadName}Img`] = obj.url;
      this[`${this.uploadName}Loading`] = false;
      this[this.uploadName] = obj.fileName;
      if (this.firstPhotoImg && this.secondPhotoImg && this.thirdPhotoImg && this.livePhotoImg) {
        this.disabled2 = false;
      }
    },
    onChangeFileFun(obj) {
      if (obj.code && obj.code === 'maxSize') {
        this.$bus.$emit('tip', { text: this.$t('personal.exccAuthForm.text3'), type: 'error' });
      }
      this.uploadName = obj.name;
      this[`${this.uploadName}Loading`] = true;
    },
    incomeChange(item) {
      this.income = item.code;
    },
    inputChanges(value, name) {
      this[name] = value.trim();
    },
    checkFocus(name) {
      switch (name) {
        case 'email': { // email
          this.checkErrorFlag1 = false;
          this.errorText1 = '';
          break;
        }
        case '2': { // emailCode
          break;
        }
        default: { // newpassword again
          // console.log(1);
        }
      }
    },
    btnLink(num) {
      if (num === 1) {
        this.active = '2';
      } else if (num === 3) {
        this.active = '1';
      } else {
        this.loading = true;
        const info = {
          fullName: this.full_name,
          // 性别
          sex: this.sex,
          birthday: this.birthday,
          city: this.city,
          address: this.address,
          postcode: this.postcode,
          certificateNumber: this.certificateNumber,
          country: `+${this.country}`,
          numberCode: this.kycPhone,
          income: this.income,
          firstPhoto: this.firstPhoto,
          secondPhoto: this.secondPhoto,
          thirdPhoto: this.thirdPhoto,
          livePhoto: this.livePhoto,
          otherIncomeDesc: this.qtTExt,
        };
        this.$store.dispatch('exccAuthRealname', info);
      }
    },
    onChangeCalendar(data) {
      this.birthday = data;
    },
    // 选择性别
    selectGender(id) {
      this.sex = id;
    },
    countryChange(item) {
      this.country = item.code;
      this.countryKeyCode = item.keyCode;
    },
    validateAge() {
      if (!this.ageLimit) {
        return true;
      }
      const birthday1 = this.birthday.split('-');
      const convert2Date = new Date(birthday1[0], birthday1[1], birthday1[2]);
      let nowDate = new Date(); // 获取当前时间
      const year = nowDate.getFullYear();
      const month = nowDate.getMonth() + 1;
      const date = nowDate.getDate();
      nowDate = new Date(year, month, date);
      const age = nowDate.getTime() - convert2Date.getTime(); // 毫秒
      let leapYear = 0; // 有多少个闰年
      for (let i = 0; i <= this.ageLimit; i += 1) {
        if ((i % 4 === 0 && i % 100 !== 0) || i % 400 === 0) {
          leapYear += 1;
        }
      }
      const YearNumber = this.ageLimit - leapYear;
      const betweenNumer = 86400000 * 365 * YearNumber + 86400000 * 366 * leapYear;
      return age >= betweenNumer;
    },
  },
};

</script>
<style lang="scss" scoped>
.user-management-excc-auth-form {
  width: 100%;

  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }

  .user-management-center i {
    width: 14px;
  }

  .certification-process {
    margin: 40px 95px;
    position: relative;
    text-align: center;
  }

  .certification-process div p {
    font-size: 14px;
    line-height: 24px;
  }

  .step-left {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding-right: 10px;
  }

  .step-center {
    display: inline-block;
    position: relative;
    z-index: 2;
    padding: 0 10px;
  }

  .step-right {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding-left: 10px;
  }

  .certification-process .div-line {
    width: 100%;
    position: absolute;
    left: 0;
    top: 11px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    z-index: 1;
  }

  .span-mark {
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
    margin-right: 10px;
  }

  .idAuth-center {
    float: left;
    width: 380px;
    margin: 0 300px;
    padding-bottom: 100px;
  }

  .upload1, .upload2, .upload3, .upload4 {
    float: left;
  }

  .upload1 div.upload1-left,
    .upload2 div.upload2-left,
    .upload3 div.upload2-left,
    .upload4 div.upload2-left,
    .upload1 div.upload1-right,
    .upload2 div.upload2-right,
    .upload3 div.upload2-right,
    .upload4 div.upload2-right  {
    width: 180px;
    height: 120px;
    float: left;
    box-sizing: border-box;
    border-radius: 2px;
  }

  .upload1 div.upload1-left,
  .upload2 div.upload2-left,
  .upload3 div.upload2-left
  .upload4 div.upload2-left {
    border-width: 1px;
    border-style: dashed;
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    svg {
      margin: 40px 78px 10px 78px;
    }

    p {
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      padding: 0 5px;
    }

    .mmd-loading-circle-right, .mmd-loading-circle-left {
      border-color: rgba(27, 170, 236, 1);
    }

    .loading-Img {
      position: absolute;
      z-index: 2;
    }

    .loading-img {
      width: 180px;
      height: 120px;
      margin: 0;
    }

    .loading-mc {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.7;
      }
    }
  }

  .upload2, .upload3,.upload4 {
    margin-top: 20px;
  }

  .upload-text {
    float: left;
    font-size: 12px;
    line-height: 20px;
    margin-top: 34px;
    margin-bottom: 26px;
  }

  .upload_file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .common-button-loading {
    position: absolute;
    vertical-align: middle;
    left: 50%;
    margin-left: -17px;
    top: 45px;
    transform: translateY(-50%);
  }

  .loading-text {
    margin-top: 70px;
  }

  .audit-information {
    text-align: center;

    svg {
      margin: 80px 0 15px 0;
    }
  }
  .audit-information p {
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }
  .gender {
      padding: 10px 0 20px;
      label {
        margin-left: 50px;
      }
      .common-redio {
        margin-right: 5px;
      }
    }
}
</style>
